"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VistaContainer = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
function VistaContainer(_a) {
    var children = _a.children;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
            justifyContent: "center",
            height: "100%",
        } },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                my: [undefined, "30px"],
            } },
            theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                    bg: theme_1.theme.colors.backgroundBlue,
                    position: "relative",
                    alignSelf: [undefined, "center"],
                    my: "auto",
                    minHeight: ["100%", "auto"],
                    minWidth: ["100%", "auto"],
                } },
                theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                        alignSelf: "center",
                        width: ["100%", "450px"],
                        textAlign: "center",
                        padding: [2, 6],
                    } }, children)))));
}
exports.VistaContainer = VistaContainer;
